module.exports = ".btn-map {\n  margin-left: 1vh;\n  margin-right: 1vh; }\n"